import { FC, useEffect } from "react";
import { useForm } from "aio-input";
import { I_city, I_ettelaateFardi } from "../types";
import { useFreelancer } from "../context";
import Icon from "@mdi/react";
import { mdiCalendar, mdiInformation, mdiInformationOutline } from "@mdi/js";
import { I_CTX } from "./../context";

const EttelaateFardi: FC<{
    data: Partial<I_ettelaateFardi>,
    onChange: (v: I_ettelaateFardi) => void,
    setDisabled: (v: boolean) => void
}> = (props) => {
    const { switchConfig } = useFreelancer()
    const { options, popup, cities } = useFreelancer()
    const form = useForm<I_ettelaateFardi>({
        initData: props.data, fa: true, inlineLabel: true,
        onChange: (data) => {
            props.onChange(data);
            const disabled = form.isSubmitDisabled()
            props.setDisabled(disabled)
        },
        isRequired: (row, field) => {
            return true
        },
        getLayout: (context) => {
            const rowCls = 'p-v-12- gap-16-'
            return {
                className: 'gap-16-',
                v: [
                    {
                        v: [
                            {
                                className: rowCls,
                                h: [
                                    { flex: 1, input: { label: 'نام و نام خانوادگی', field: 'name', type: 'text' } },
                                    { flex: 1, input: { label: 'کد ملی', field: 'nationalCode', type: 'text', validateType: "irNationalCode" } },
                                    { flex: 1, input: { label: 'شماره موبایل', field: 'mobile', type: 'text', validateType: "irMobile", filter: ['number'] } },
                                    { flex: 1, input: { label: 'نام پدر', field: 'fatherName', type: 'text' } }
                                ]
                            },
                            {
                                className: rowCls,
                                h: [
                                    { flex: 1, input: { label: 'پست الکترونیکی', field: 'email', type: 'text', validateType: 'email' } },
                                    {
                                        flex: 1,
                                        input: {
                                            label: 'تاریخ تولد', field: 'birthDate', type: 'date', jalali: true, size: 16,
                                            option: {
                                                close: () => true
                                            },
                                            after: <Icon path={mdiCalendar} size={0.8} color='#555' />, caret: false, placeholder: ' '
                                        }
                                    },
                                    {
                                        flex: 1,
                                        input: {
                                            label: 'جنسیت', field: 'gender' as any, type: 'select',
                                            options: options.sexTypes.map((o: any) => ({ text: o.value, value: o.key })),
                                            popover: { fitHorizontal: true }
                                        }
                                    },
                                    { flex: 1, input: { label: 'شماره تلفن ثابت', field: 'phone', type: 'text', filter: ['number'] } },
                                ]
                            },
                            {
                                className: rowCls,
                                h: [
                                    { flex: 1, input: { label: 'شماره ضروری', field: 'essentialPhone', type: 'text', filter: ['number'] } },
                                    {
                                        flex: 1,
                                        input: {
                                            label: 'شهر', field: 'shahr', type: 'select', search: 'جستجو',popover:{fitHorizontal:true},
                                            options: cities,
                                            option:{
                                                text:(o)=>o.text.split(' - ')[1],
                                                value:(o)=>o.id,
                                                before:(o)=><div style={{whiteSpace:'nowrap'}}>{`${o.text.split(' - ')[0]} - `}</div>
                                            }

                                        }
                                    },
                                    { 
                                        flex: 1, 
                                        input: { 
                                            label: 'هاب', field: "hub" as any, search: 'جستجو', type: 'select', options: options.hubs.map((o: any) => ({ text: o.name, value: o.id })),
                                            popover:{fitHorizontal:true}
                                        } 
                                    },
                                    { flex: 1, input: { field: 'isActive', label: '', type: 'checkbox', switch: switchConfig, text: 'فعال' } },

                                ]
                            },
                            {
                                className: rowCls,
                                h: [
                                    { flex: 1, input: { label: 'آدرس محل سکونت', field: 'address', type: 'text' } }
                                ]
                            },

                        ]
                    }
                ]
            }
        }
    })
    useEffect(() => {
        const res = form.errors.getErrorsList()
        props.setDisabled(!!res.length)
    }, [])
    const errors = form.errors.getErrorsList(false).filter((o)=>!!o)
    return (
        <>
            {form.renderLayout}
            {
                errors.length > 0 && 
                <div className="fs-12- m-t-8- p-h-12- flex-row- align-v- gap-6-" style={{color:'red'}}>
                    <Icon path={mdiInformationOutline} size={0.8} color='red'/>
                    {errors[0]}
                </div>
            }
        </>
    )
}
export default EttelaateFardi

export const ettelaateFardiLayout = (context:I_CTX) => {
    const { options, cities,switchConfig } = context;
    
    const rowCls = 'p-v-12- gap-16-'
    return {
        className: 'gap-16-',
        v: [
            {
                v: [
                    {
                        className: rowCls,
                        h: [
                            { flex: 1, input: { label: 'نام و نام خانوادگی', field: 'name', type: 'text' } },
                            { flex: 1, input: { label: 'کد ملی', field: 'nationalCode', type: 'text', validateType: "irNationalCode" } },
                            { flex: 1, input: { label: 'شماره موبایل', field: 'mobile', type: 'text', validateType: "irMobile", filter: ['number'] } },
                            { flex: 1, input: { label: 'نام پدر', field: 'fatherName', type: 'text' } }
                        ]
                    },
                    {
                        className: rowCls,
                        h: [
                            { flex: 1, input: { label: 'پست الکترونیکی', field: 'email', type: 'text', validateType: 'email' } },
                            {
                                flex: 1,
                                input: {
                                    label: 'تاریخ تولد', field: 'birthDate', type: 'date', jalali: true, size: 18, placeholder: ' ', caret: false,
                                    option: {
                                        close: () => true
                                    },
                                    after: <Icon path={mdiCalendar} size={0.8} color='#555' />
                                }
                            },
                            {
                                flex: 1,
                                input: {
                                    label: 'جنسیت', field: 'gender' as any, type: 'select',
                                    options: options.sexTypes.map((o: any) => ({ text: o.value, value: o.key })),
                                    popover: { fitHorizontal: true }
                                }
                            },
                            { flex: 1, input: { label: 'شماره تلفن ثابت', field: 'phone', type: 'text', filter: ['number'] } },
                        ]
                    },
                    {
                        className: rowCls,
                        h: [
                            { flex: 1, input: { label: 'شماره ضروری', field: 'essentialPhone', type: 'text', filter: ['number'] } },
                            {
                                flex: 1,
                                input: {
                                    label: 'شهر', field: 'shahr', type: 'select', search: 'جستجو',
                                    options: cities.map((o: any) => ({ text: o.text, value: o.id }))
                                }
                            },
                            { flex: 1, input: { label: 'هاب', field: "hub" as any, search: 'جستجو', type: 'select', options: options.hubs.map((o: any) => ({ text: o.name, value: o.id })) } },
                            { flex: 1, input: { field: 'isActive', label: '', type: 'checkbox', switch: switchConfig, text: 'فعال' } },

                        ]
                    },
                    {
                        className: rowCls,
                        h: [
                            { flex: 1, input: { label: 'آدرس محل سکونت', field: 'address', type: 'text' } }
                        ]
                    },

                ]
            }
        ]
    }
}
